import React from 'react';
import { ConnectWallet, darkTheme } from "@thirdweb-dev/react";
import './LandingPage.css'; // We'll create this CSS file
import ADLogoMerch from '../styles/images/new/ADLogoMerch.png'; // Corrected import path

const LandingPage: React.FC = () => {
  return (
    <div className="landing-page-container">
      <div className="landing-content">
        <div className="landing-text">
          <h1 className="fa head">Welcome to The City</h1>
          <p className="fb body-text">
            A vast reward system for the Analog Distortions by Wrath. 
            Connect your wallet to stake your Analog Distortions. Earn AURA which is used 
            to explore the City and bring in sponsored rewards for being collectors of the 
            haunted Distortions.
          </p>
          <div className="connect-wallet-wrapper">
            <ConnectWallet
              className="ccbutton"
              style={{ fontFamily: 'Doctor Glitch', fontWeight: 'normal', fontStyle: 'oblique', color: 'white' }}
              theme={darkTheme({
                fontFamily: "Hacked, sans-serif",
                colors: {
                  modalBg: "#002020",
                  accentText: "cyan",
                  primaryText: "#ffffff",
                  secondaryText: "#cccccc",
                  connectedButtonBg: "#003030",
                  primaryButtonBg: "#004040",
                  primaryButtonText: "cyan",
                }
              })}
            />
          </div>
        </div>
        <div className="landing-image-container">
          {/* Ensure ADLogoMerch.png is in your public folder or adjust path */}
          <img src={ADLogoMerch} alt="Analog Distortions Logo" className="landing-image" />
        </div>
      </div>
      <span className="developer-credit-landing fb">Developed by <a href="https://x.com/SnapsNoCaps" target="_blank" rel="noopener noreferrer">snaps</a> with 🩵</span>
    </div>
  );
};

export default LandingPage; 